import { createContext } from "react";

interface NavbarContextOptions {
  collapsed: boolean;
  /** True only for the render in which the phone navigation overlay closes. */
  hasPhoneNavJustClosed: boolean;
  toggleCollapsed: () => void;
}

export const NavbarContext = createContext<NavbarContextOptions>({
  collapsed: true,
  hasPhoneNavJustClosed: false,
  toggleCollapsed: () => null,
});
